import { render, staticRenderFns } from "./employee-access-config.vue?vue&type=template&id=1d3b646e&scoped=true&"
import script from "./employee-access-config.vue?vue&type=script&lang=js&"
export * from "./employee-access-config.vue?vue&type=script&lang=js&"
import style0 from "./access-config.css?vue&type=style&index=0&id=1d3b646e&prod&scoped=true&lang=css&"
import style1 from "./access-config-noscoped.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3b646e",
  null
  
)

export default component.exports